
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.017 13.383V9.25H7.4v1.383h5.883v1.384H7.4v1.366H6.017zm-5.3-1.366v-1.384h4.5v1.384h-4.5zM3.833 9.05V7.683H.717V6.317h3.116v-1.4h1.384V9.05H3.833zm2.184-1.367V6.317h7.266v1.366H6.017zM8.783 4.75V.617h1.384v1.366h3.116v1.384h-3.116V4.75H8.783zM.717 3.367V1.983h7.266v1.384H.717z"}})])
          )
        }
      }
    